// extracted by mini-css-extract-plugin
export default {"menu":"src-components-common-DashboardNavigator-DashboardDropdown-index__menu--MEdJa","active":"src-components-common-DashboardNavigator-DashboardDropdown-index__active--xf9QP"};